import { createContext, useContext, useEffect, useState, useCallback } from "react";

const AppCtx = createContext(null);

const ACCENTS = {
  zeta: { accent: "#1F7FC4", accent2: "#2ECBD9", soft: "rgba(31,127,196,0.10)" },
  atez: { accent: "#3FA34D", accent2: "#A8D93B", soft: "rgba(63,163,77,0.10)" },
};

export function AppProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("zeta_lang") || "tr");
  const [guide, setGuideState] = useState(() => localStorage.getItem("zeta_guide") || null);
  const [gateOpen, setGateOpen] = useState(() => !localStorage.getItem("zeta_guide_seen"));

  useEffect(() => {
    const a = ACCENTS[guide] || ACCENTS.zeta;
    const r = document.documentElement.style;
    r.setProperty("--accent", a.accent);
    r.setProperty("--accent-2", a.accent2);
    r.setProperty("--accent-soft", a.soft);
  }, [guide]);

  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    localStorage.setItem("zeta_lang", l);
    setLangState(l);
  }, []);

  const setGuide = useCallback((g) => {
    localStorage.setItem("zeta_guide_seen", "1");
    if (g) localStorage.setItem("zeta_guide", g);
    else localStorage.removeItem("zeta_guide");
    setGuideState(g);
    setGateOpen(false);
  }, []);

  const t = useCallback((obj) => (typeof obj === "string" ? obj : obj?.[lang] ?? obj?.tr ?? ""), [lang]);

  return (
    <AppCtx.Provider value={{ lang, setLang, guide, setGuide, gateOpen, setGateOpen, t }}>
      {children}
    </AppCtx.Provider>
  );
}

export const useApp = () => useContext(AppCtx);
